import { FC, HTMLAttributes } from 'react';

export type WidgetSlotProps = HTMLAttributes<HTMLDivElement> & {
  visible: boolean;
};

export const WidgetSlot: FC<WidgetSlotProps> = ({ visible = true, children }) => {
  return <>{visible && children}</>;
};
